export default __webpack_public_path__ + "static/media/calendar.aa1b598b.svg";